module.exports = __webpack_public_path__ + "img/qrcodepayment.f7e5c389.png";